/**
 * @description 判断浏览器是 PC 还是 Mobile
 */
export const getIsMobile = () => {
  if (typeof window === 'undefined') return false;
  const userAgentInfo = window.navigator.userAgent;
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ];
  return Agents.some((v) => userAgentInfo.includes(v));
};
